module.exports = __webpack_public_path__ + "static/media/tonyAvatar.08d3360b.png";